import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from '@shared/services/storage.service';
import { UserService } from '@shared/services/user.service';
import { AccountFlagsController } from './controllers/account.flags.controller';
import { AccountFlagsModel } from './model/account.flags.model';

@Component({
	selector: 'app-featureflags',
	templateUrl: './view/featureflags.component.html',
	styleUrl: './view/featureflags.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class FeatureFlagsComponent implements AfterViewInit {
	@ViewChild('networkErrorDialog')
	networkErrorDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('unknownErrorDialog')
	unknownErrorDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('confirmationDialog')
	confirmationDialog: ElementRef<HTMLDialogElement>;

	public model: AccountFlagsModel;
	public controller: AccountFlagsController;
	public constructor(httpClient: HttpClient, sessionStorageService: SessionStorageService, userService: UserService, translator: TranslateService) {
		this.model = new AccountFlagsModel();
		this.controller = new AccountFlagsController(httpClient, this.model, sessionStorageService, userService, translator);
	}

	public ngAfterViewInit(): void {
		this.model.confirmationDialog = this.confirmationDialog.nativeElement;
		this.model.unknownErrorDialog = this.unknownErrorDialog.nativeElement;
		this.model.networkErrorDialog = this.networkErrorDialog.nativeElement;
	}
}
